<template>
  <div>
    <div class="d-flex flex-row flex-wrap justify-content-start mb-2">
      <!-- Botones -->
      <div class="w-100">
        <div class="d-flex">
          <Button
            :size="15"
            color="#fd7e14"
            colorText="#ffffff"
            tooltip="Filtrar contenido"
            icon="fas fa-filter"
            round
            class="mr-2"
            :width="30"
            @click.native="openModal('modal', 1)"
            traslate
          />

          <Button
            :size="15"
            color="#dc3545"
            colorText="#ffffff"
            tooltip="Borrar contenido Filtrado"
            icon="fas fa-filter"
            round
            :width="30"
            class="mr-2"
            traslate
            @click.native="removeFilters()"
          />

          <Button
            :size="15"
            color="#28a745"
            colorText="#ffffff"
            tooltip="Exportar a Excel"
            icon="icon fas fa-file-excel"
            round
            :width="30"
            class="mr-2"
            @click.native="openModal('modal', 2)"
            traslate
          />
        </div>
      </div>
    </div>

    <ui-modal ref="modal"
              :title="is_report_filter ? 'Filtrar datos para reporte de planificaciones semanales' : 'Filtros para planificaciones semanales'"
              size="large">
      <!-- Fila 1 -->
      <div>
        <!-- Row 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Región"
            placeholder="Seleccionar"
            v-model="routeModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psCharterFiltroRoutes"
          />

          <ui-select
            class="w-50"
            has-search
            label="Cliente"
            placeholder="Seleccionar"
            v-model="clienteModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psCharterFiltroClientes"
          />
        </div>

        <!-- Row 2 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="POD"
            placeholder="Seleccionar"
            v-model="podModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psCharterFiltroPods"
          />

          <ui-select
            class="w-50"
            has-search
            label="Especie"
            placeholder="Seleccionar"
            v-model="especieModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psCharterFiltroEspecies"
          />
        </div>

        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Pallet"
            placeholder="Seleccionar"
            v-model="palletModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psCharterFiltroPallets"
          />
        </div>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <button class="btn btn-default" @click="closeModal('modal')">
          Cerrar
        </button>
        <div style="float: right">
          <button class="btn btn-outline-secondary" @click="clear">
            Limpiar
          </button>
          <button class="btn btn-outline-danger ml-2" @click="is_report_filter ? generarReporte() : filtrar()"
                  :disabled="!filter_btn_active">
            {{ filter_btn_text }}
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";

import Button from "../../common/Button";
import { mapActions, mapState } from "vuex";
import { downloadReportePlanificacionSemanalCharter, filtrarPlanificacionSemanal } from "@/constants/charter";
import uuid from "keen-ui/src/helpers/uuid";

export default {
  components: { Button, UiModal },
  data() {
    return {
      //filtros
      podModel: "",
      clienteModel: "",
      palletModel: "",
      especieModel: "",
      routeModel: "",
      //otros
      is_report_filter: false,
      filter_btn_text: "Filtrar",
      filter_btn_active: true
    };
  },
  computed: {
    ...mapState("charter", [
        "psCharterDataDatatableGeneral",
        "psCharterFiltroClientes",
        "psCharterFiltroPallets",
        "psCharterFiltroEspecies",
        "psCharterFiltroPods",
        "psCharterFiltroRoutes",
        "psCharterShowDetail",
        "psCharterCurrentRegion",
        "psCharterCurrentWeek"
      ]
    )
  },
  methods: {
    ...mapActions("charter", [
      "actionSetDataDatatableDetailFiltradaPSCharter",
      "actionSetDataDatatableGeneralFiltradaPSCharter",
      "actionSetDataDatatableGeneralNoFiltradaPSCharter",
      "actionSetDataDatatableDetailNoFiltradaPSCharter"
    ]),
    openModal(ref, type) {
      if (type !== 1) {
        this.is_report_filter = true;
        this.filter_btn_text = "Generar reporte";
      } else {
        this.filter_btn_text = "Filtrar";
        this.is_report_filter = false;
      }
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
      this.is_report_filter = false;
    },
    clear() {
      this.podModel = "";
      this.clienteModel = "";
      this.palletModel = "";
      this.routeModel = "";
      this.especieModel = "";
      this.loadingButton(true);
    },
    async filtrar() {

      this.$vToastify.loader("Filtrando planificaciones semanales...");

      this.loadingButton(true);

      let response = await filtrarPlanificacionSemanal(
        {
          specie_id: this.especieModel.id ?? null,
          client_id: this.clienteModel.id ?? null,
          pod_id: this.podModel.id ?? null,
          pallet_id: this.palletModel.id ?? null,
          route_id: this.routeModel.id ?? null
        }
      );

      if (response.code === 200) {

        this.actionSetDataDatatableGeneralFiltradaPSCharter(response.data);

        if (this.psCharterShowDetail) {
          const results = response.data.find(x => x.data[0] === this.psCharterCurrentRegion[1]);
          this.actionSetDataDatatableDetailFiltradaPSCharter(results !== undefined && results.data_complementaria.weeks[this.psCharterCurrentWeek].length >= 1 ? results.data_complementaria.weeks[this.psCharterCurrentWeek] : []);
        }

        this.closeModal("modal");

      } else if (response.code && response.errors) {

        Object.values(response.errors).forEach(errorArray => {
          errorArray.forEach(error => {
            this.$vToastify.error(error, "Error");
          });
        });

      } else {

        this.$vToastify.error(response.message, "Se produjo un error");

      }

      this.loadingButton(true);

      this.$vToastify.stopLoader();
    },
    async generarReporte() {

      this.$vToastify.loader("Generando reporte de bookings confirmados...");

      this.loadingButton(false);

      let filters = {
        specie_id: this.especieModel.id ?? null,
        client_id: this.clienteModel.id ?? null,
        pod_id: this.podModel.id ?? null,
        pallet_id: this.palletModel.id ?? null,
        route_id: this.routeModel.id ?? null
      };

      await downloadReportePlanificacionSemanalCharter(filters, uuid.short("reporte-planificacion-semanal-charter-ucc-"));

      this.$vToastify.stopLoader();

      this.loadingButton(true);

      this.closeModal("modal");
    },
    loadingButton(active) {
      if (!active) {
        this.filter_btn_text = this.is_report_filter ? "Generando reporte..." : "Filtrando...";
        this.filter_btn_active = active;
      } else {
        this.filter_btn_text = this.is_report_filter ? "Generar reporte" : "Filtrar";
        this.filter_btn_active = active;
      }
    },
    async removeFilters() {
      if (this.psCharterShowDetail) {
        await this.actionSetDataDatatableGeneralNoFiltradaPSCharter();
        const results = this.psCharterDataDatatableGeneral.find(x => x.data[0] === this.psCharterCurrentRegion[1]);
        this.actionSetDataDatatableDetailFiltradaPSCharter(results !== undefined && results.data_complementaria.weeks[this.psCharterCurrentWeek].length >= 1 ? results.data_complementaria.weeks[this.psCharterCurrentWeek] : []);
      } else {
        this.actionSetDataDatatableGeneralNoFiltradaPSCharter();
      }
    }
  }

};
</script>

<style>

</style>